import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "pathfinder" }
const _hoisted_2 = { class: "card mb-3 shadow-sm" }
const _hoisted_3 = { class: "card-body pb-1" }
const _hoisted_4 = { class: "card-text" }
const _hoisted_5 = { class: "intro pb-4" }
const _hoisted_6 = {
  key: 0,
  class: "my-3 d-flex align-items-center"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("strong", null, "Asked the XRP Ledger to find paths...", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border ms-auto",
  role: "status",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "mt-0 pt-0 mb-3" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "card w-100 shadow-sm" }
const _hoisted_15 = {
  class: "card-header text-center text-white bg-primary fw-bold h4 py-1",
  style: {"white-space":"nowrap","overflow":"hidden","text-overflow":"ellipsis"}
}
const _hoisted_16 = { class: "card-body pb-4 text-center" }
const _hoisted_17 = ["href"]
const _hoisted_18 = { style: {"bottom":"0","position":"absolute","left":"0","right":"0","margin-bottom":"10px"} }
const _hoisted_19 = {
  class: "d-block px-2",
  style: {"white-space":"nowrap","text-overflow":"ellipsis","overflow":"hidden"}
}
const _hoisted_20 = { key: 1 }
const _hoisted_21 = {
  key: 2,
  style: {"position":"relative"}
}
const _hoisted_22 = { key: 1 }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "alert alert-danger text-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "pb-2" }, [
    /*#__PURE__*/_createElementVNode("b", null, "No paths found.")
  ]),
  /*#__PURE__*/_createTextVNode(" Could be due to insufficient liquidity. ")
], -1)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = {
  key: 2,
  class: "alert alert-danger mb-2 mt-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h5", {
        class: _normalizeClass(["card-header", { 'text-white bg-primary': 1 === 1 }])
      }, " 4. Path Finding 🎉 "),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _renderSlot(_ctx.$slots, "default")
          ])
        ]),
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_9))
          : (_openBlock(), _createElementBlock("div", _hoisted_10, [
              (_ctx.paths && _ctx.paths.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createElementVNode("h5", _hoisted_12, " Found " + _toDisplayString(_ctx.paths.length) + " path(s) to deliver " + _toDisplayString(typeof this.command.destination_amount === "string"
                  ? Number(this.command.destination_amount) / 1_000_000
                  : this.command.destination_amount.value) + " " + _toDisplayString(typeof this.command.destination_amount === "string"
                  ? "XRP"
                  : _ctx.currencyCodeFormat(this.command.destination_amount.currency)), 1),
                    _createElementVNode("div", _hoisted_13, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paths, (path, i) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "mb-4 col-12 col-lg-3 col-md-4 col-sm-6 d-flex align-self-stretch flex-wrap",
                          key: i
                        }, [
                          _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("div", _hoisted_15, _toDisplayString(typeof path.source_amount === "string"
                        ? "XRP"
                        : _ctx.currencyCodeFormat(path.source_amount.currency)), 1),
                            _createElementVNode("div", _hoisted_16, [
                              (typeof path.source_amount !== 'string')
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    target: "_blank",
                                    href: 
                        'https://bithomp.com/explorer/' +
                        path.paths_computed?.[0]?.[0]?.account
                      
                                  }, [
                                    _createElementVNode("small", _hoisted_18, [
                                      _createElementVNode("code", _hoisted_19, _toDisplayString(path.paths_computed?.[0]?.[0]?.account), 1)
                                    ])
                                  ], 8, _hoisted_17))
                                : _createCommentVNode("", true),
                              (typeof path.source_amount === 'string')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                    _createElementVNode("h4", null, _toDisplayString(path.source_amount / 1_000_000), 1)
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                    _createElementVNode("h4", null, _toDisplayString(path.source_amount.value), 1)
                                  ]))
                            ])
                          ])
                        ]))
                      }), 128))
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_22, _hoisted_24))
            ])),
        (!_ctx.loading && _ctx.error !== '')
          ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(_ctx.error), 1))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}